import { render, staticRenderFns } from "./VocationOrderItemize.vue?vue&type=template&id=67b5ad16"
import script from "./VocationOrderItemize.vue?vue&type=script&lang=js"
export * from "./VocationOrderItemize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports